var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyRbIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.774,
    height: 24.774,
    viewBox: "0 0 24.774 24.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "why-icon-3",
    d: "M0,19.611v2.066c0,1.708,4.161,3.1,9.29,3.1s9.29-1.389,9.29-3.1V19.611c-2,1.408-5.652,2.066-9.29,2.066S2,21.019,0,19.611ZM15.484,6.194c5.129,0,9.29-1.389,9.29-3.1S20.613,0,15.484,0s-9.29,1.389-9.29,3.1S10.355,6.194,15.484,6.194ZM0,14.535v2.5c0,1.708,4.161,3.1,9.29,3.1s9.29-1.389,9.29-3.1v-2.5c-2,1.645-5.656,2.5-9.29,2.5S2,16.181,0,14.535Zm20.129.532c2.773-.537,4.645-1.534,4.645-2.681V10.321a11.882,11.882,0,0,1-4.645,1.669ZM9.29,7.742C4.161,7.742,0,9.474,0,11.613s4.161,3.871,9.29,3.871,9.29-1.732,9.29-3.871S14.419,7.742,9.29,7.742ZM19.9,10.466c2.9-.523,4.873-1.548,4.873-2.724V5.676C23.056,6.89,20.1,7.544,17,7.7A5.419,5.419,0,0,1,19.9,10.466Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyRbIcon3);
export default __webpack_public_path__ + "static/media/why-rb-icon-3.5eb355ca04f8f8b5914c8349c3f89df1.svg";
export { ForwardRef as ReactComponent };